// extracted by mini-css-extract-plugin
module.exports = {"container":"terms_container__zpoK9"};